import { EtiquetaCampoRequest } from '../etiqueta/etiqueta-campo.request';

export class ProdutoEtiquetaItemRequest {
  idProduto: number;
  quantidade?: number;
  idsLoteSelecionados?: number[];
  idsSerieSelecionadas?: number[];
}

export class ProdutoGerarDadosEtiquetaRequest {
  idListaPreco?: number | null;
  idListaPrecoPromocional?: number | null;
  idLocalizacaoEstoque?: number | null;
  usarQuantidadeEstoque: boolean;
  produtos: ProdutoEtiquetaItemRequest[];
  campos: EtiquetaCampoRequest[];
}

export class ProdutoEtiquetaOpcoesCodigoCompostoRequest {
  idLocalizacaoEstoque?: number | null;
  usarQuantidadeEstoque: boolean;
  produtoIds: number[] = [];
}
